import { MainHeader, Section, SectionParagraph } from '@/components/shared/Content';
import JoinCTA from '@/components/shared/JoinCTA';
import { useShowHeaderCtaOnScroll } from '@/hooks/useShowHeaderCtaOnScroll';
import pressBanner from '@/static/assets/home/press_banner_without_inc.svg';
import heroLeftSide from '@/static/pet/compare/hero-left-side.png';
import heroRightSide from '@/static/pet/compare/hero-right-side.png';
import { PRODUCT_PET } from '@/utils/products';
import { Box, Flex } from '@lemonade-hq/cdk';
import parse from 'html-react-parser';
import Image from 'next/image';
import React from 'react';
import styled from 'styled-components';

const PressBanner = styled(Image)<{ show: boolean }>`
  opacity: 0.6;
  margin-top: 60px;
  opacity: ${({ show }) => (show ? 1 : 0)};
  transition: opacity 0.5s;
  width: 100%;
`;

const PressBannerWrapper = styled(Flex)`
  overflow: auto;
`;

const MainCta = styled(JoinCTA)`
  padding-inline: 35px;
`;

const HeroSideImage = styled(Image)<{ show: boolean }>`
  position: absolute;
  width: auto;
  bottom: 0;
  opacity: ${({ show }) => (show ? 1 : 0)};
  transition: opacity 0.5s;
  pointer-events: none;
`;

const HeroLeftSideImage = styled(HeroSideImage)`
  height: 490px;
  left: 50%;
  transform: translateX(-50%);
  margin-left: -620px;
  margin-bottom: -160px;
`;

const HeroRightSideImage = styled(HeroSideImage)`
  height: 600px;
  right: 50%;
  transform: translateX(50%);
  margin-right: -690px;
  margin-bottom: -160px;
`;

export interface CompareHeroProps {
  title: string;
  subtitle: string;
  mainCta: string;
}

export const CompareHero: React.FC<CompareHeroProps> = ({ title, subtitle, mainCta }) => {
  const { ref } = useShowHeaderCtaOnScroll();
  const [count, setCount] = React.useState(0);

  return (
    <Section pt={[40, 70]} pb={[70]} flexDirection="column" gap="20px" width="100%" position="relative">
      <HeroLeftSideImage src={heroLeftSide} alt="" show={count === 3} onLoadingComplete={() => setCount(c => c + 1)} />
      <HeroRightSideImage
        src={heroRightSide}
        alt=""
        show={count === 3}
        onLoadingComplete={() => setCount(c => c + 1)}
      />
      <Flex px="20px" flexDirection="column" gap="20px">
        <MainHeader>{parse(title)}</MainHeader>
        <SectionParagraph>{parse(subtitle)}</SectionParagraph>
        <Box mx="auto" mt="48px">
          <MainCta
            size="big"
            flavor="primary"
            product={PRODUCT_PET}
            analyticsParams={{
              pet_lp_type: 'compare',
              variant: 'compare',
            }}
            glowing
            ref={ref}
            data-event="pet_compare_landing_page.get_quote.clicked"
            data-event-Param-Section="hero"
            data-source="pet"
          >
            {mainCta}
          </MainCta>
        </Box>
      </Flex>
      <Box display={['none', 'flex']} maxWidth="875px">
        <PressBannerWrapper>
          <PressBanner
            src={pressBanner}
            alt="press banner"
            height={46}
            show={count === 3}
            onLoadingComplete={() => setCount(c => c + 1)}
          />
        </PressBannerWrapper>
      </Box>
    </Section>
  );
};
